/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {getGlobalProp} from '../props/GlobalPropsConfig';

export type UseGridColumnGlobalPropsReturnType = {
  searchEnabled?: boolean;
  orderEnabled?: boolean;
}

/**
 * @useGridColumnGlobalProps
 *
 * Provides a Hook which returns searchEnabled and orderEnabled from `GlobalProp` values.
 *
 * ```typescript
 *
 *    const {
 *      searchEnabled,
 *      orderEnabled
 *    } = useGridColumnGlobalProps();
 *
 *    ...
 *    
 *    applyColumnOrdering(columns, orderEnabled);
 *
 *    <Render.If condition={searchEnabled}>
 *      <ColumnSearch setSearchTerm={setSearchTerm} />
 *    </Render.If>
 *
 * ```
 */
export const useGridColumnGlobalProps = (): UseGridColumnGlobalPropsReturnType => ({
  searchEnabled : getGlobalProp('grid.column.search.enabled', false),
  orderEnabled  : getGlobalProp('grid.column.order.enabled', false)
});

export default useGridColumnGlobalProps;
